<template>
  <div ref="container">
    <a-modal
      :title="title"
      width="80%"
      :visible="visible"
      :confirmLoading="confirmLoading"
      :maskStyle="{'top':'93px','left':'154px'}"
      :wrapClassName="wrapClassNameInfo()"
      :mask="isDesktop()"
      :maskClosable="false"
      @ok="handleOk"
      @cancel="handleCancel"
      cancelText="取消"
      okText="保存"
      style="top:5%;height: 90%;">
      <template slot="footer">
        <a-button key="back" v-if="isReadOnly" @click="handleCancel">
          取消
        </a-button>
      </template>
      <a-form :form="form" id="makeCodeModal" >
        <a-col :md="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规则名称">
            <a-input placeholder="请输入规则名称" v-model="data.ruleName" v-show="false"/>{{ data.ruleName ? data.ruleName : '暂无数据' }}
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规则编码">
            <a-input placeholder="请输入规则编码" v-model="data.ruleCode" v-show="false"/>{{ data.ruleCode ? data.ruleCode : '暂无数据' }}
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发码机构">
            <a-input placeholder="请输入发码机构" v-model="data.ruleSystem" v-show="false"/>{{ data.ruleSystem ? data.ruleSystem : '暂无数据' }}
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="参考标准">
            <a-input placeholder="请输入参考标准" v-model="data.ruleCategory" v-show="false"/>{{ data.ruleCategory ? data.ruleCategory : '暂无数据' }}
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="更新时间">
            <a-input placeholder="请输入更新时间" v-model="data.updateTime" v-show="false"/>{{ data.updateTime ? data.updateTime : '暂无数据' }}
          </a-form-item>
        </a-col>
        <a-col :md="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
            <a-input placeholder="请输入备注" v-model="data.remark" v-show="false"/>{{ data.remark ? data.remark : '暂无数据' }}
          </a-form-item>
        </a-col>

        <div v-for="item in makeCodeArr" :key="item.keyCode">
          <a-divider />
<!--          {{item}}-->
          <!-- 0：常量  1：变量  2：日期  3：标准字典  4：自定义字典  5：序列号  6：当前日期   -->
          <!-- 0：常量  1：变量  2：日期  3：标准字典  4：自定义字典  5：序列号  6：当前日期   -->
          <!-- 0：常量  1：变量  2：日期  3：标准字典  4：自定义字典  5：序列号  6：当前日期   -->

          <!-- begin keyName 这一组  -->

          <a-col :md="12" v-if="item.keyType === '2'">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="item.keyName">
              <a-date-picker placeholder="请输入日期" v-model="item.keyValue" style="width: 100%"/>
            </a-form-item>
          </a-col>

          <a-col :md="12" v-if="item.keyType === '0' || item.keyType === '1' ">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="item.keyName">
              <a-input placeholder="请输入内容" v-model="item.keyValue" v-if="item.keyType === '1'"/><div v-if="item.keyType === '0' || item.keyType === '3' || item.keyType === '4'">{{ item.keyValue ? item.keyValue : '暂无数据' }}</div>
            </a-form-item>
          </a-col>

          <a-col :md="12" v-if="item.keyType === '5' || item.keyType === '6' ">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="类型">
              {{item.keyType === '5' ? '序列号' : '当前日期'}}
            </a-form-item>
          </a-col>

          <a-col :md="12" v-if=" item.keyType === '3' || item.keyType === '4'">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="item.keyName">
              <a-select placeholder="选择单据状态"  v-model="item.keyValue">
                <a-select-option v-for="x in item.dictSelectOptions" :value="x.dictValue" :key="x.dictValue">{{x.dictLable}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <!-- end keyName 这一组  -->

          <a-col :md="12" v-if="item.keyType === '5' || item.keyType === '1'">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="节点长度">
              {{ item.keyLenghth ? item.keyLenghth - item.priKey.length : '暂无数据' }}
            </a-form-item>
          </a-col>

          <a-col :md="12" v-if="item.keyType === '5'">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号起始号">
              <a-input placeholder="请输入序列号起始号" v-model="item.keyDescription.startNum"/>
            </a-form-item>
          </a-col>
          <a-col :md="12" v-if="item.keyType === '5'">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号中止号">
              <a-input placeholder="请输入序列号中止号" v-model="item.keyDescription.endNum"/>
            </a-form-item>
          </a-col>
          <a-col :md="12" v-if="item.keyType === '5'">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="步长">
              <a-input placeholder="请输入步长" v-model="item.keyDescription.step"/>
            </a-form-item>
          </a-col>
          <a-col :md="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序号">
              <a-input placeholder="请输入序号" v-model="item.seq" type="number"/>
            </a-form-item>
          </a-col>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
  import pick from 'lodash.pick'
  import {beforeIdCode, createIdCode, queryDictDataByDictId} from '@/api/identifierCode/identifierCode'
  import {autoJumpNextInput} from "@/utils/util"
  import {mixinDevice} from '@/utils/mixin'
  import JSelectMultiple from '@/components/jeecg/JSelectMultiple'
  export default {
    name: "MakeCodeModal",
    mixins: [mixinDevice],
    components: {
      JSelectMultiple
    },
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        enabledSwitch: true, //是否启用
        isReadOnly: false,
        jselectMultiple: {
          options: [
            { text: '编辑', value: '1' },
            { text: '审核', value: '2' },
            { text: '反审核', value: '7' },
            { text: '导出', value: '3' },
            { text: '启用禁用', value: '4' },
            { text: '打印', value: '5' },
            { text: '作废', value: '6' }
          ],
          value: ''
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{

        },
        data: null,
        ruleId: null, // 编码规则的ID
        makeCodeArr: null // 生码数组
      }
    },
    created () {
    },
    methods: {
      onChange(checked) {
        this.model.enabled = checked
      },
      getMakeCode(qve, qve2) {
        this.ruleId = qve
        beforeIdCode({ ruleId: qve }).then( res => {

          if ( res.code !== 200 ) {
            this.$message.warning( `异常${res.message}`,1)
          } else {
            this.makeCodeArr = res.result.params
            this.data = res.result
            this.data.ruleSystem = qve2.ruleSystem
            this.data.ruleCategory = qve2.ruleCategory

            //查询字典options
            this.makeCodeArr.forEach(mc=>{
              if(mc.keyType == '3' || mc.keyType == '4'){
                queryDictDataByDictId({dictId: mc.keyDescription.dicCode})
                  .then(res => {
                    this.$set(mc,'dictSelectOptions',res.result)
                  })
              }
            })
          }
        })
        this.visible = true;
      },
      add () {
        this.edit({});
        this.model.enabled = true
        this.enabledSwitch = true
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(record.enabled!=null){
          this.enabledSwitch = record.enabled?true:false;
        }
        if(this.model.uuid){
          this.jselectMultiple.value = record.pushBtn
        } else {
          this.jselectMultiple.value = ''
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'ruleName', 'name', 'parentNumber', 'parentName', 'url', 'component', 'sort', 'pushBtn', 'icon', 'enabled'))
          autoJumpNextInput('functionModal')
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {

            //校验
            let backFlag = false
            console.log('values==>',this.makeCodeArr)
            this.makeCodeArr.forEach(row=>{
              if(!row.seq && row.seq != 0){
                backFlag = row.keyName + '序号必填且需为正整数'
              }

              if(row.keyType == '1'
                && !/^[a-zA-Z0-9]+$/.test(row.keyValue)){
                backFlag = row.keyName + '的值只能为数字或字母格式'
              }

              if(row.keyType == '5'
                && !(Number.isInteger(row.keyDescription.startNum) && row.keyDescription.startNum > 0)
                && !(Number.isInteger(row.keyDescription.endNum) && row.keyDescription.endNum > 0)
                && !(Number.isInteger(row.keyDescription.step) && row.keyDescription.step > 0)
                && !(parseInt(row.keyDescription.endNum) > parseInt(row.keyDescription.startNum))){
                backFlag = row.keyName + '序列号类型输入有误,起始结束步长皆需为正整数,且结束应大于起始数值'
              }

              if(row.keyType == '5' &&
                ((row.keyDescription.endNum + '').length > (
                  row.keyDescription['length'] -
                  ( row.keyDescription.priKey ? row.keyDescription.priKey.length : 0 )
                  )
                )
              ){
                backFlag = '序列号数值超出节点长度范围'
              }

              if(row.keyType != '5' && row.keyType != '6'){
                if(!row.keyValue){
                  backFlag = `${row.keyName}未填写完全`
                }
              }
            })
            if(backFlag){
              this.$message.warning(backFlag)
              return false
            }

            this.makeCodeArr.forEach(row=>{
              if(row.keyType == '4' || row.keyType == '3'){
                const d = row.dictSelectOptions.find(so=>so.dictValue == row.keyValue)
                row.keyDescription.itemCode = d.uuid
                row.keyDescription.itemValue = d.dictLable
                // delete row.dictSelectOptions
              }
            })

            that.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            formData.pushBtn = this.jselectMultiple.value
            let obj;

            if(!this.model.id){
              obj=createIdCode({
                ruleId: this.ruleId,
                params: JSON.stringify( this.makeCodeArr )
              });
              console.log('成功', this.makeCodeArr)
            }else{
              console.log('失败')
            }
            obj.then((res)=>{
              if(res.code === 200){
                that.$emit('ok');
                that.close();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateNumber(rule, value, callback){
        let params = {
          number: value,
          id: this.model.id?this.model.id:0
        };
        checkNumber(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("编号已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      validateName(rule, value, callback){
        let params = {
          name: value,
          id: this.model.id?this.model.id:0
        };
        checkFunction(params).then((res)=>{
          if(res && res.code===200) {
            if(!res.data.status){
              callback();
            } else {
              callback("名称已经存在！");
            }
          } else {
            callback(res.data);
          }
        });
      },
      onSearchParentNumber() {
        this.$refs.functionTreeModal.edit(this.model.id);
        this.$refs.functionTreeModal.title = "选择上级编号";
        this.$refs.functionTreeModal.disableSubmit = false;
      }
    }
  }
</script>
<style scoped>

</style>